import { Map } from "immutable";

export default {
  list: Map()
}
